// Every field service page's parent route (PRD 95 §4.13): the installable
// page's manifest, the scoped service worker (and its Web Push, PRD 108), and
// the "new version" prompt —
// then the page itself. Mounted once for `/business/field/*`, so the rest of
// the app never registers or is controlled by the worker.

import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { YStack } from 'tamagui';
import { GBAlert } from '@greenbackapp/ui';
import { applyFieldUpdate, onFieldUpdate, startFieldServiceWorker } from './fieldServiceWorker';
import { syncFieldPush } from './fieldPush';
import { startQueue } from './fieldWriteQueue';
import { FieldQueueBanner } from './FieldQueueBanner';
import { useFieldManifest } from './useFieldManifest';

export const FieldShell: React.FC = () => {
  useFieldManifest();
  const [updateReady, setUpdateReady] = useState(false);

  useEffect(() => {
    // Push re-registers on every launch while permission stands (PRD 108).
    void startFieldServiceWorker().then(syncFieldPush);
    // Presses kept with no signal send as soon as there is some (PRD 108 §4.4).
    startQueue();
    return onFieldUpdate(setUpdateReady);
  }, []);

  return (
    <>
      {updateReady && (
        <YStack paddingHorizontal="$4" paddingTop="$3">
          <GBAlert
            variant="info"
            message="A new version of Greenback is ready."
            action={{ label: 'Reload', onPress: applyFieldUpdate }}
          />
        </YStack>
      )}
      <FieldQueueBanner />
      <Outlet />
    </>
  );
};

export default FieldShell;
